<template>
    <el-dialog
        class="ssm-load-unload-operate-dialog"
        :title="(currentId ? '编辑' : '新增') + '装卸闲置人员'"
        :visible.sync="visible"
        :close-on-click-modal="false"
        top="4%"
        width="980px"
        :before-close="close">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="mini">
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="contacts" label="联系人">
                        <el-input v-model.trim="form.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="contactNumber" label="联系电话">
                        <el-input v-model.trim="form.contactNumber" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="peopleNumber" label="人数">
                        <el-input v-model.trim="form.peopleNumber" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="postCode" label="岗位">
                        <MSelect
                            :value="form.postCode"
                            @input="val => handleChange(val, 'postCode')"
                            :optionNum="'SRM_POST_TYPE'"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="provinceCode" label="意向省份">
                        <el-select v-model="form.provinceCode" clearable @change="handleProvinceChange">
                            <el-option
                                v-for="option in provinceOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="cityCode" label="意向城市">
                        <el-select v-model="form.cityCode" clearable :disabled="!form.provinceCode" @change="handleCityChange">
                            <el-option
                                v-for="option in cityOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="areaCode" label="意向区县">
                        <el-select v-model="form.areaCode" clearable :disabled="!form.cityCode" @change="handleAreaChange">
                            <el-option
                                v-for="option in areaOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="measurementUnitCode" label="计量单位">
                        <MSelect
                            :value="form.measurementUnitCode"
                            @input="val => handleChange(val, 'measurementUnitCode')"
                            :optionNum="'IDLE_DEMAND_RESOURCES_METER_TYPE'"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="bottomPrice" label="最低价/元">
                        <el-input v-model.trim="form.bottomPrice" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="maximumPrice" label="最高价/元">
                        <el-input v-model.trim="form.maximumPrice" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="startTime" label="开始日期">
                        <el-date-picker
                            v-model="form.startTime"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择日期"
                            :clearable="true"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="endTime" label="结束日期">
                        <el-date-picker
                            v-model="form.endTime"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择日期"
                            :clearable="true"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item prop="remark" label="备注说明">
                        <el-input
                            type="textarea"
                            v-model.trim="form.remark"
                            placeholder="请输入"
                            :rows="4"
                            maxlength="200"
                            :show-word-limit="true"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="comfirm">保存</el-button>
            <el-button type="primary" :loading="pubLoading" @click="publish">保存并发布</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import dayjs from 'dayjs';
import { getCitys, getDistricts } from '../../../utils/getArea.js'
import { getLoadIdleResources, addLoadIdleResources, editLoadIdleResources, releaseLoadIdleResources } from '../../../api/storageSupManage/idleResource.js';
import { getPersons } from '../../../api/register/person.js';
import { phoneVerify } from '../../../constant/formRegular.js';
import MSelect from '@/components/lots/otpSelect2/index.vue';

const INITFORM = {
    contacts: '',
    contactNumber: '',
    peopleNumber: '',
    postCode: '',
    provinceCode: '',
    cityCode: '',
    areaCode: '',
    provinceName: '',
    cityName: '',
    areaName: '',
    measurementUnitCode: '',
    bottomPrice: '',
    maximumPrice: '',
    startTime: '',
    endTime: '',
    remark: '',
};

const RULES = {
    contacts: [
        { required: true, message: '请输入联系人', trigger: ['blur', 'change'] },
        { max: 30, message: '限制输入30个字符', trigger: ['blur', 'change'] }
    ],
    contactNumber: [
        { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    peopleNumber: [
        { required: true, message: '请输入人数', trigger: ['blur', 'change'] },
        { pattern: /^[1-9]\d{0,9}$/, message: '请输入10位以内正整数', trigger: ['blur', 'change'] },
    ],
    postCode: [{ required: true, message: '请输入岗位', trigger: ['blur', 'change'] }],
    provinceCode: [{ required: true, message: '请选择意向省份', trigger: ['blur', 'change'] }],
    cityCode: [{ required: true, message: '请选择意向城市', trigger: ['blur', 'change'] }],
    measurementUnitCode: [{ required: true, message: '请选择计量单位', trigger: ['blur', 'change'] }],
    bottomPrice: [
        { required: true, message: '请输入最低价', trigger: ['blur', 'change'] },
        { pattern: /^(0\.[1-9])$|^([1-9]\d{0,5}(\.\d)?)$/, message: '支持6位正整数，小数点保留1位', trigger: ['blur', 'change'] },
    ],
    maximumPrice: [
        { required: true, message: '请输入最高价', trigger: ['blur', 'change'] },
        { pattern: /^(0\.[1-9])$|^([1-9]\d{0,5}(\.\d)?)$/, message: '支持6位正整数，小数点保留1位', trigger: ['blur', 'change'] },
    ],
    startTime: [
        { required: true, message: '请选择开始日期', trigger: ['blur', 'change'] },
        {
            validator: (rule, value, callback) => {
                if (value && (new Date(value)).getTime() < (new Date()).setHours(0, 0, 0, 0)) {
                    callback(new Error('开始日期不能小于当前日期'));
                } else {
                    callback();
                }
            },
            trigger: ['blur', 'change']
        }
    ],
    endTime: [{ required: true, message: '请选择结束日期', trigger: ['blur', 'change'] }],
};

export default {
    components: { MSelect },
    props: {
        provinceOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentId: '',
            visible: false,
            form: { ...INITFORM },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < (new Date()).setHours(0, 0, 0, 0);
                },
            },
            loading: false,
            pubLoading: false,
            // provinceOptions: [],
            cityOptions: [],
            areaOptions: [],
        };
    },
    computed: {
        ...mapState(['supplier']),
        ...mapGetters(['user', 'currentTenant']),
        rules() {
            return {
                ...RULES,
                maximumPrice: [
                    { required: true, message: '请输入最高价', trigger: ['blur', 'change'] },
                    { pattern: /^(0\.[1-9])$|^([1-9]\d{0,5}(\.\d)?)$/, message: '支持6位正整数，小数点保留1位', trigger: ['blur', 'change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (Number(value) < Number(this.form.bottomPrice)) {
                                callback(new Error('最高价不能低于最低价'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                endTime: [
                    { required: true, message: '请选择结束日期', trigger: ['blur', 'change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (value && (new Date(value)).getTime() < (new Date()).setHours(0, 0, 0, 0)) {
                                callback(new Error('结束日期不能小于当前日期'));
                            } else if (value && this.form.startTime) {
                                if (value < this.form.startTime) {
                                    callback(new Error('结束日期不能小于开始时间'));
                                } else if (dayjs(value).subtract(1, 'second').diff(this.form.startTime, 'month') > 0) {
                                    callback(new Error('开始-结束时间最多只能选择一个月'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
            }
        }
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.currentId = row.id;
                this.load(row);
            } else {
                if (this.supplier) {
                    this.setSupplierContactInfo()
                } else {
                    this.form.contacts = this.user.userName
                    this.form.contactNumber = this.user.mobile
                }
            }
        },
        close() {
            this.currentId = '';
            this.form = { ...INITFORM };
            this.cityOptions = []
            this.areaOptions = []
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.visible = false;
            });
        },
        load(row) {
            getLoadIdleResources(row.id).then(res => {
                if (res && +res.code === 0) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = res.data[key];
                    });
                    this.setRegionOptions()
                }
            }).catch(err => {});
        },
        comfirm() {
            this.$refs.form.validate().then(valid => {
                const operate = this.currentId ?
                    { api: editLoadIdleResources, successMsg: '编辑成功!' } :
                    { api: addLoadIdleResources, successMsg: '新增成功!' };
                this.loading = true;
                operate.api(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(operate.successMsg);
                        this.close();
                        this.$emit('refresh');
                    }
                }).finally(() => { this.loading = false; });
            }).catch(err => {});
        },
        publish() {
            this.$refs.form.validate().then(valid => {
                this.pubLoading = true;
                releaseLoadIdleResources(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存并发布成功!');
                        this.close();
                        this.$emit('refresh');
                    }
                }).finally(() => { this.pubLoading = false; });
            }).catch(err => {});
        },
        getParams() {
            const params = { ...this.form };
            params.tenantCode = this.currentTenant.tenantCode;
            if (this.currentId) {
                params.id = this.currentId;
                params.updateUserCode = this.user.userCode;
                params.updateUserName = this.user.userName;
            } else {
                params.createUserCode = this.user.userCode;
                params.createUserName = this.user.userName;
            }
            return params;
        },
        handleChange(val, prop) {
            this.form[prop] = val;
        },
        setRegionOptions() {
            if (this.form.provinceCode) {
                getCitys(this.form.provinceCode).then(res => {
                    this.cityOptions = res;
                })
            }
            if (this.form.cityCode) {
                getDistricts(this.form.cityCode).then(res => {
                    this.areaOptions = res;
                })
            }
        },
        handleProvinceChange(val) {
            this.form.cityCode = '';
            this.form.areaCode = '';
            this.form.provinceName = val ? this.provinceOptions.find(item => item.value === val).label : '';
            this.form.cityName = '';
            this.form.areaName = '';
            this.cityOptions = [];
            this.areaOptions = [];
            if (val) {
                getCitys(val).then(res => {
                    this.cityOptions = res;
                })
            }
        },
        handleCityChange(val) {
            this.form.areaCode = '';
            this.form.cityName = val ? this.cityOptions.find(item => item.value === val).label : '';
            this.form.areaName = '';
            this.areaOptions = [];
            if (val) {
                getDistricts(val).then(res => {
                    this.areaOptions = res;
                })
            }
        },
        handleAreaChange(val) {
            this.form.areaName = val ? this.areaOptions.find(item => item.value === val).label : '';
        },
        setSupplierContactInfo() {
            const params = {
                pageNo: 1,
                pageSize: 99999,
                supplierCode: this.supplier.supplierCode
            }
            getPersons(params).then(res => {
                if (res && +res.code === 0) {
                    // userType=1 为主账号
                    const mainItem = res.data.list.find(item => +item.userType === 1)
                    if (mainItem) {
                        this.form.contacts = mainItem.contacts
                        this.form.contactNumber = mainItem.contactsMobile
                    }
                }
            })
        },
    },
    // mounted() {
    //     dictWithUrl('SYS_BUSINESS_CATEGORY').then(res => {
    //         if (res && +res.code === 0) {
    //             this.dictData = res.data;
    //             this.obtValueList = Object.keys(this.dictData.SYS_BUSINESS_CATEGORY)
    //         }
    //     })
    // }
};
</script>
<style lang="less">
.ssm-load-unload-operate-dialog {
    .el-date-editor, .el-select {
        width: 100%;
    }
}
</style>